import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const ImageWithContent = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  if (module.hideSection === "no") {
    return (
      <section className="bg-white-100">
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`zigzag py-80 lgscreen:py-30${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid"
          >
            <div className="flex flex-wrap items-center">
              <div
                className={`lg:w-6/12 w-full ${
                  module?.imagePosition === "right"
                    ? "order-2 lgscreen:order-1"
                    : ""
                }`}
              >
                {module?.image && (
                  <motion.div variants={animFade} className="img small">
                    <ImageOpt
                      imgData={module.image.mediaItemUrl}
                      width={1000}
                      height={800}
                      imgAlt={module.image.altText}
                      imgLoad="lazy"
                      imgClass="w-full object-cover"
                    />
                  </motion.div>
                )}
              </div>
              <div
                className={`lg:w-6/12 w-full ${
                  module?.imagePosition === "right"
                    ? "order-1 lgscreen:order-2"
                    : ""
                }`}
              >
                <div
                  className={`zigzag-content laptop:px-40 lgscreen:px-0 lgscreen:pt-30 ${
                    module?.imagePosition === "right"
                      ? "pl-110 pr-80"
                      : "pl-80 pr-110"
                  }`}
                >
                  {module?.heading && (
                    <motion.h3 variants={animFade}>{module.heading}</motion.h3>
                  )}
                  {module?.description && (
                    <motion.div variants={animFade} className="content pt-15">
                      {parse(module.description)}
                    </motion.div>
                  )}
                  {module?.button && (
                    <motion.div variants={animFade} className="mt-30">
                      <Link
                        to={module.button.url}
                        className="btn btn-border"
                        target={module.button.target}
                      >
                        {module.button.title}
                      </Link>
                    </motion.div>
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default ImageWithContent
export const PageImageWithContentFragment = graphql`
  fragment PageImageWithContentFragment on WpPage_Pagecontent_PageContent_ImageWithContent {
    extraId
    extraClass
    hideSection
    heading
    description
    imagePosition
    image {
      altText
      mediaItemUrl
    }
    button {
      target
      title
      url
    }
  }
`
